module.exports = __webpack_public_path__ + "static/media/horizon.9b6003f4.jpg";